import { 
    CContainer, 
    CFloatingWhatsapp, 
    CFloatingShippingTime, 
    CPageWrapper, 
    CBreadcrumbItem,
    CPageSite,
    CPagination,
    CPaginationItem,
    CTotalPagination,
    CSelectCustom,
    CProgressBar,
    CWidgetFeatured,
    CCardAccount,
    CSidebarAccount
} from './styled'

export default {
    'container-app': CContainer,
    'floating-whatsapp': CFloatingWhatsapp,
    'floating-shipping-time': CFloatingShippingTime,
    'page-wrapper': CPageWrapper,
    'breadcrumb-item': CBreadcrumbItem,
    'page-site': CPageSite,
    'c-pagination': CPagination,
    'page-item': CPaginationItem,
    'total-pagination': CTotalPagination,
    'select-custom': CSelectCustom,
    'progress-bar': CProgressBar,
    'widget-featured': CWidgetFeatured,
    'c-card-account': CCardAccount,
    'c-sidebar-account': CSidebarAccount
}